import axios from "axios";
import React from "react";
import compareDesc from "date-fns/compareDesc";
import endOfDay from "date-fns/endOfDay";
import isToday from "date-fns/isToday";
import isAfter from "date-fns/isAfter";
import getMonth from "date-fns/getMonth";
import { CountDown1 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown1";
import { CountDown2 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown2";
import { CountDown3 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown3";
import { CountDown4 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown4";
import { CountDown5 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown5";
import { CountDown6 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown6";
import { CountDown7 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown7";
import { CountDown8 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown8";
import { CountDown9 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown9";
import { CountDown10 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown10";
import { CountDown11 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown11";
import { CountDown12 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown12";
import { CountDown13 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown13";
import { CountDown14 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown14";
import { CountDown15 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown15";
import { CountDown16 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown16";
import { CountDown17 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown17";
import { CountDown18 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown18";
import { CountDown19 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown19";
import { CountDown20 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown20";
import { CountDown21 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown21";
import { CountDown22 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown22";
import { CountDown23 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown23";
import { CountDown24 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown24";
import { CountDown25 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown25";
import { CountDown26 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown26";
import { CountDown27 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown27";
import { CountDown28 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown28";
import { CountDown29 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown29";
import { CountDown30 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown30";
import { CountDown31 } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/CountDown31";
import { Utils } from "services/utils";
import { Sorting } from "services/sorting";
import {
  INVOICE_SUMMARY_HEADERS,
  INVOICE_DETAIL_HEADERS,
  INVOICE_ICONS,
  INVOICE_STATUS,
} from "utils/BillingConstants";

export const FILTERS = {
  ALL: "All Invoices",
  CURRENT: Sorting.getMonth(new Date()),
  LAST3: Sorting.getPrev3Months(new Date()),
  PAID: "Paid",
  UNPAID: "Unpaid",
};
export const INVOICES_STATUS = {
  OVERDUE: "OVERDUE",
  DUE_TODAY: "DUE_TODAY",
  DUE_FUTURE: "DUE_FUTURE",
  NONE_DUE: "NONE_DUE",
};

export const SORT_OPTIONS = {
  INVOICE_DATE_DESC: "Sent Date - DESC",
  INVOICE_DATE_ASC: "Sent Date - ASC",
  DUE_DATE_DESC: "Due Date - DESC",
  DUE_DATE_ASC: "Due Date - ASC",
  INVOICE_NUM_DESC: "Invoice # - DESC",
  INVOICE_NUM_ASC: "Invoice # - ASC",
};

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/billing`;
//const BASE_URL = "http://localhost:8082";
const config = {
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
};

const billingNumbers = [
  <CountDown1 />,
  <CountDown2 />,
  <CountDown3 />,
  <CountDown4 />,
  <CountDown5 />,
  <CountDown6 />,
  <CountDown7 />,
  <CountDown8 />,
  <CountDown9 />,
  <CountDown10 />,
  <CountDown11 />,
  <CountDown12 />,
  <CountDown13 />,
  <CountDown14 />,
  <CountDown15 />,
  <CountDown16 />,
  <CountDown17 />,
  <CountDown18 />,
  <CountDown19 />,
  <CountDown20 />,
  <CountDown21 />,
  <CountDown22 />,
  <CountDown23 />,
  <CountDown24 />,
  <CountDown25 />,
  <CountDown26 />,
  <CountDown27 />,
  <CountDown28 />,
  <CountDown29 />,
  <CountDown30 />,
  <CountDown31 />,
];

export class BillingApi {
  static getCountDownNumber(number) {
    return billingNumbers[number];
  }

  static submitPayment = (params) => {
    const url = `${BASE_URL}/payment/`;

    return axios.post(url, params, config);
  };

  getAll(orgId, filters, intacctId) {
    const no = intacctId ? intacctId : 0;
    if (!filters) {
      const url = `${BASE_URL}/${orgId}/invoices/${no}`;
      return axios.get(url, config).then((response) => {
        return response;
      });
    } else {
      const url = `${BASE_URL}/${orgId}/invoices/${no}?status=Due,Overdue`;
      return axios.get(url, config).then((response) => {
        const { intacctInvoices, invoices } = response.data;
        if (intacctInvoices && intacctInvoices.length !== 0) {
          return response;
        } else {
          if (invoices && invoices.length !== 0) {
            return this.filterAll(response);
          } else {
            return [];
          }
        }
      });
    }
  }

  filterAll(response) {
    const { invoices } = response.data;
    for (const invoice of invoices) {
      const filteredTransactions = [];

      for (const transaction of invoice?.transaction) {
        if (
          transaction.transactionType === "Payment" ||
          transaction.transactionType === "Full refund" ||
          transaction.transactionType === "Partial refund" ||
          transaction.transactionType === "Reverse charge" ||
          transaction.transactionType === "Disputed" ||
          transaction.transactionType === "Credit" ||
          transaction.transactionType === "Credit Card"
        ) {
          transaction.amount = this.formatCurrency(`${transaction.amount}`);
          transaction.outstandingBalance = this.formatCurrency(
            `${transaction.outstandingBalance}`
          );
          transaction.invoiceTotal = this.formatCurrency(
            `${transaction.invoiceTotal}`
          );
          filteredTransactions.push(transaction);
        }
      }
      invoice.transactions = filteredTransactions;
    }

    invoices.sort(function (left, right) {
      return compareDesc(new Date(left.dueDate), new Date(right.dueDate));
    });
    return response;
  }

  get(invoiceId, orgId, type) {
    let url = "";

    if (type && type.includes("intacct")) {
      url = `${BASE_URL}/${orgId}/invoice/${invoiceId}/intacct`;
    } else {
      url = `${BASE_URL}/${orgId}/invoice/${invoiceId}`;
    }

    return axios.get(url, config);
  }

  getSummary(orgId, recordNo) {
    const no = recordNo ? recordNo : 0;
    const url = `${BASE_URL}/${orgId}/${no}/summary`;
    return axios.get(url, config);
  }

  getInvoiceTransactions(orgId, invoiceId) {
    const url = `${BASE_URL}/${orgId}/invoice/transactions/${invoiceId}`;
    return axios.get(url, config);
  }

  getContract(intacctId) {
    const url = `${BASE_URL}/contracts/${intacctId}`;
    return axios.get(url, config);
  }

  getPayments(numberOfPayments, orgId, intacctId) {
    const no = intacctId ? intacctId : 0;
    const url = `${BASE_URL}/payment/${orgId}/transaction/${
      numberOfPayments !== undefined ? numberOfPayments : ""
    }/${no}`;
    return axios.get(url, config);
  }

  viewPdfInPanel(pdf) {
    const blob = this.getPdfBlob(pdf);
    const fileUrl = URL.createObjectURL(blob);

    return fileUrl;
  }

  downloadPdf(pdf, invoiceId) {
    // Set filename
    const filename = `Invoice-${invoiceId}.pdf`;
    const blob = this.getPdfBlob(pdf);

    // Create temporary element to simulate clicking a download link
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getPdfBlob(pdf) {
    // Set filename
    // let filename = "invoice.pdf";

    // Convert Base64 PDF to ArrayBuffer
    const binary = atob(pdf.replace(/\s/g, ""));
    const { length } = binary;
    const buffer = new ArrayBuffer(length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < length; i++) {
      view[i] = binary.charCodeAt(i);
    }

    // Create Blob from ArrayBuffer
    const blob = new Blob([view], { type: "application/pdf" });

    return blob;
  }

  formatDate(date) {
    let formattedDate = " - ";

    if (date) {
      /* Match YYYY-MM-DD date format */
      const incomingDateFormat = /([\d]{4})-([\d]{2})-([\d]{2})/;
      const dateMatch = incomingDateFormat.exec(date);

      if (dateMatch) {
        /* Only represent two digit year */
        const year = dateMatch[1].substr(2);
        formattedDate = `${dateMatch[2]}.${dateMatch[3]}.${year}`;
      }
    }
    return formattedDate;
  }
  formatCurrency(amount) {
    if (amount && amount === "PAID") {
      return amount;
    } else if (amount) {
      let amountWithoutCommas = amount;
      if (typeof amountWithoutCommas === "string") {
        amountWithoutCommas = amountWithoutCommas.replace(",", "");
        amountWithoutCommas = amountWithoutCommas.replace("$", "");
      }

      return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amountWithoutCommas);
    }
  }
}

export class BillingUtils {
  /**
   * Group invoices into buckets
   */
  static splitInvoices = (invoices) => {
    const today = endOfDay(new Date());
    const overdue = [];
    const dueToday = [];
    const dueFuture = [];
    const notDue = [];
    invoices.forEach((invoice) => {
      // eslint-disable-next-line
      invoice.dueDate = endOfDay(new Date(invoice.dueDate));
      // eslint-disable-next-line
      invoice.billcycle = endOfDay(new Date(invoice.billcycle));

      if (isToday(invoice.dueDate) && invoice.amount_due > 0) {
        dueToday.push(invoice);
      } else if (
        invoice.status === "Due" &&
        isAfter(today, invoice.dueDate) &&
        invoice?.amount !== "0"
      ) {
        dueFuture.push(invoice);
      } else if (invoice.status === "Overdue") {
        overdue.push(invoice);
      } else {
        notDue.push(invoice);
      }
    });

    return { overdue, dueToday, dueFuture, notDue, all: invoices };
  };
  static massageData = (data, headers) => {
    if (!data) {
      return [];
    }
    return data.map((invoice) => {
      const formattedTransactions = invoice?.transaction
        ? invoice.transaction.map((txn) => ({
            ...txn,
            effectiveDate: Utils.formatInvoiceDate(txn.effectiveDate),
            amount: new BillingApi().formatCurrency(txn?.amount),
          }))
        : [];

      const newObj = { transactions: formattedTransactions };

      Object.keys(headers).forEach(
        (header) =>
          (newObj[header] = BillingUtils.formatting(header, invoice[header]))
      );

      if (invoice.status === "Overdue") {
        newObj.hasAlert = true;
      }

      const amountDue = parseInt(invoice.amount_due);

      if (amountDue === 0.0) {
        newObj.amount_due = "$0.00";
      }

      newObj.status = invoice.status;
      newObj.invoiceId = invoice.invoiceid;
      newObj.billcycle = invoice.billcycle;
      newObj.theme = BillingUtils.getInvoiceTheme(invoice);
      newObj.summaryHeaders = BillingUtils.getHeaders(newObj);
      newObj.detailHeaders = INVOICE_DETAIL_HEADERS;
      newObj.type = invoice?.type;
      if (invoice?.type === "intacct") {
        newObj.docId = invoice?.docid;
        newObj.soRecordNo = invoice?.soRecordNo;
      }

      return newObj;
    });
  };

  static getHeaders = (record) => {
    if (record.hasAlert) {
      const customHeaders = { ...INVOICE_SUMMARY_HEADERS };
      customHeaders.amount_due = "Due Today";
      // customHeaders['amountDue'] = 'Amount Due Today';

      return customHeaders;
    } else {
      return INVOICE_SUMMARY_HEADERS;
    }
  };
  static getInvoiceStatus = (invoices) => {
    let status = INVOICES_STATUS.NONE_DUE;
    const splitInvoices = BillingUtils.splitInvoices(invoices);
    // const splitInvoices = BillingUtils.splitInvoices(invoices.concat(sampleInvoice));
    if (splitInvoices.dueToday.length > 0) {
      status = INVOICES_STATUS.DUE_TODAY;
    } else if (splitInvoices.overdue.length > 0) {
      status = INVOICES_STATUS.OVERDUE;
    } else if (splitInvoices.dueFuture.length > 0) {
      status = INVOICES_STATUS.DUE_FUTURE;
    }

    return { invoices: splitInvoices, status };
  };

  static formatting(type, data) {
    switch (type) {
      case "billcycle":
        return Utils.formatInvoiceDate(data);
      case "dueDate":
        return Utils.formatInvoiceDate(data);
      case "effectiveDate":
        return Utils.formatInvoiceDate(data);
      case "amount_due":
        return new BillingApi().formatCurrency(data);
      case "amount":
        return new BillingApi().formatCurrency(data);
      case "invoice_number":
        return `#${data}`;
      default:
        return data;
    }
  }

  static getInvoiceTheme(invoice) {
    switch (invoice.status) {
      case INVOICE_STATUS.PAID:
        return {
          icon: INVOICE_ICONS[INVOICE_STATUS.PAID],
          bannerColor: "purple",
        };
      case INVOICE_STATUS.DUE:
        return { icon: INVOICE_ICONS[INVOICE_STATUS.DUE], bannerColor: "blue" };
      case INVOICE_STATUS.PAST_DUE:
        return {
          icon: INVOICE_ICONS[INVOICE_STATUS.PAST_DUE],
          bannerColor: "orange",
        };
      default:
        return { icon: INVOICE_ICONS[INVOICE_STATUS.DUE], bannerColor: "blue" };
    }
  }

  static getInvoices(invoices, amount) {
    if (invoices) {
      const tempInvoices = [...invoices];
      const sortedInvoices = BillingUtils.sort(tempInvoices);

      return sortedInvoices.slice(0, amount);
    }
  }
  static getTransactionType(type) {
    let transactionType = null;
    const typeLower = type ? type.toLowerCase() : "";

    if (
      typeLower === "payment" ||
      typeLower === "credit" ||
      typeLower === "credit card" ||
      typeLower === "deffered discount" ||
      typeLower === "reverse charge" ||
      typeLower === "reverse charge earned" ||
      typeLower === "write off"
    ) {
      transactionType = "debit";
    } else if (typeLower === "charge" || typeLower === "purchase") {
      transactionType = "credit";
    }

    return transactionType;
  }

  static sort(invoices) {
    return invoices.sort((a, b) => {
      return compareDesc(new Date(a.billcycle), new Date(b.billcycle));
    });
  }
  static sortById(invoices) {
    return invoices.sort((a, b) => {
      return Number(b.id) - Number(a.id);
    });
  }

  static sortDueDate(data) {
    return data.sort((a, b) => {
      return compareDesc(new Date(a.dueDate), new Date(b.dueDate));
    });
  }

  static formatIntacctInvoice = (intacctInvoices) => {
    const invoices = [];
    if (!intacctInvoices || intacctInvoices?.length === 0) {
      return [];
    }
    for (const i of intacctInvoices) {
      invoices.push({
        billcycle: i?.created,
        dueDate: i?.due,
        amount: i?.paid,
        amount_due: i?.totalDue,
        status: this.getStatus(i?.state),
        invoice_number: i?.recordNo,
        invoiceid: i?.recordNo,
        type: "intacct",
        docid: i?.docID,
        soRecordNo: i?.soRecordNo,
      });
    }
    return this.sort(invoices);
  };

  static getStatus = (status) => {
    let matchingStatus = status;
    switch (status) {
      case "Posted":
        matchingStatus = "Due";
        break;
      case "Closed":
        matchingStatus = "Paid";
        break;
      case "Pending":
        matchingStatus = "Pending Payment";
        break;
      case "Paid":
        matchingStatus = "Paid";
        break;
      case "Reversed":
        matchingStatus = "Void";
        break;
      case "Reversal":
        matchingStatus = "Credit";
        break;
      case "Partially Paid":
        matchingStatus = "Unpaid";
        break;
      default:
        matchingStatus = status;
    }
    return matchingStatus;
  };

  static sortByNum = (field) => (a, b) => {
    const leftNum = a[field].replace(/#/, "");
    const rightNum = b[field].replace(/#/, "");

    if (leftNum > rightNum) {
      return 1;
    } else if (rightNum > leftNum) {
      return -1;
    }

    return 0;
  };

  static filterList2(data, filter = "All Invoices") {
    if (!data) {
      return [];
    }

    const currMonth = getMonth(new Date());

    switch (filter) {
      case FILTERS.ALL:
        return data;
      case FILTERS.CURRENT:
        return data.filter(
          (invoice) => getMonth(new Date(invoice.billcycle)) === currMonth
        );
      case FILTERS.LAST3:
        const lastThreeMonths = [
          currMonth - 2 < 0 ? 12 + (currMonth - 2) : currMonth - 3,
          currMonth - 1 < 0 ? 12 + (currMonth - 1) : currMonth - 2,
          currMonth - 1,
        ];

        return data.filter((invoice) => {
          const invoiceMonth = getMonth(new Date(invoice.billcycle));

          return lastThreeMonths.includes(invoiceMonth);
        });
      case FILTERS.PAID:
        return data.filter((invoice) => invoice.status === "Paid");
      case FILTERS.UNPAID:
        return data.filter(
          (invoice) => invoice.status === "Overdue" || invoice.status === "Due"
        );
      default:
        return data;
    }
  }

  static filterList(
    selected,
    data,
    currentMonth,
    prev3Months,
    latestFilteredData
  ) {
    if (selected && data.length) {
      const filterVoid = data.filter((invoice) => invoice.status !== "Void");
      // eslint-disable-next-line
      data = filterVoid;
      const filteredList = BillingUtils.getFilteredList(
        currentMonth,
        prev3Months,
        latestFilteredData,
        data
      );

      return filteredList;
    }
  }

  static getAllInvoices(selected, data, latestFilteredData) {
    let filteredList;
    if (data.length > 0) {
      filteredList = BillingUtils.billingSort(
        selected,
        data,
        latestFilteredData
      );
    } else {
      filteredList = data;
    }
    return filteredList;
  }
  static getPrevious3Months(data, selected) {
    let filteredList;
    const monthIndex2 = Sorting.getMonthIndex(new Date());
    const threeMonths = Sorting.getPreviousThreeMonths(monthIndex2, data);

    if (threeMonths.length > 0) {
      filteredList = BillingUtils.billingSort(selected, threeMonths);
    } else {
      filteredList = threeMonths;
    }
    return filteredList;
  }

  static getFilteredList(currentMonth, prev3Months, latestFilteredData, data) {
    let filteredList;
    switch (selected) {
      case "All Invoices":
        filteredList = BillingUtils.getAllInvoices(
          selected,
          data,
          latestFilteredData
        );
        break;
      case currentMonth:
        const monthIndex = Sorting.getMonthIndex(new Date()) + 1;
        const oneMonthInvoices = data.filter((invoice) => {
          let currentYear = new Date().getFullYear();
          currentYear = currentYear.toString().split("20")[1];
          const year = invoice.billcycle.split(".")[2];
          let month = "";
          if (year === currentYear) {
            month = invoice.billcycle.split(".")[0];
          }
          return monthIndex === +month;
        });

        if (oneMonthInvoices.length > 0) {
          filteredList = BillingUtils.billingSort(selected, oneMonthInvoices);
        } else {
          filteredList = oneMonthInvoices;
        }

        break;
      case prev3Months:
        filteredList = BillingUtils.getPrevious3Months(data, selected);
        break;
      case "Paid":
        const paid = data.filter((invoice) => invoice.status === "Paid");

        if (paid.length > 0) {
          filteredList = BillingUtils.billingSort(selected, paid);
        } else {
          filteredList = paid;
        }

        break;
      case "Unpaid":
        const unpaid = data.filter(
          (invoice) => invoice.status === "Overdue" || invoice.status === "Due"
        );

        if (unpaid.length > 0) {
          filteredList = BillingUtils.billingSort(selected, unpaid);
        } else {
          filteredList = unpaid;
        }
        break;
      default:
        filteredList = data;
        break;
    }
    return filteredList;
  }

  static billingSort2(data, sortParam) {
    if (!data) {
      return [];
    }

    let field;
    if (
      sortParam === SORT_OPTIONS.INVOICE_NUM_ASC ||
      sortParam === SORT_OPTIONS.INVOICE_NUM_DESC
    ) {
      field = "invoice_number";
    } else if (
      sortParam === SORT_OPTIONS.INVOICE_DATE_ASC ||
      sortParam === SORT_OPTIONS.INVOICE_DATE_DESC
    ) {
      field = "billcycle";
    } else {
      field = "dueDate";
    }

    switch (sortParam) {
      case SORT_OPTIONS.INVOICE_DATE_ASC:
        return BillingUtils.sort(data).reverse();
      case SORT_OPTIONS.DUE_DATE_ASC:
        return BillingUtils.sortDueDate(data).reverse();
      case SORT_OPTIONS.INVOICE_DATE_DESC:
        return BillingUtils.sort(data);
      case SORT_OPTIONS.DUE_DATE_DESC:
        return BillingUtils.sortDueDate(data);
      case SORT_OPTIONS.INVOICE_NUM_ASC:
        return data.sort(BillingUtils.sortByNum(field));
      case SORT_OPTIONS.INVOICE_NUM_DESC:
        return data.sort(BillingUtils.sortByNum(field)).reverse();
      default:
        return data.sort(BillingUtils.sortByNum(field));
    }
  }

  static billingSort(selected, data, latestFilteredData) {
    let sortedArray;
    if (latestFilteredData) {
      // eslint-disable-next-line
      data = latestFilteredData;
    }

    if (selected && data && data.length) {
      switch (selected) {
        case "Invoice Date (Asc)":
          sortedArray = BillingUtils.sort(data).reverse();
          break;
        case "Invoice Date (Des)":
          sortedArray = BillingUtils.sort(data);

          break;
        case "Due Date (Asc)":
          sortedArray = BillingUtils.sortDueDate(data).reverse();

          break;
        case "Due Date (Des)":
          sortedArray = BillingUtils.sortDueDate(data);

          break;
        case "Invoice # (Asc)":
          sortedArray = data.sort((a, b) => {
            return (
              a.invoice_number.split("#")[1] - b.invoice_number.split("#")[1]
            );
          });
          break;
        case "Invoice # (Des)":
          sortedArray = data
            .sort((a, b) => {
              return (
                a.invoice_number.split("#")[1] - b.invoice_number.split("#")[1]
              );
            })
            .reverse();

          break;
        default:
          sortedArray = data;
          break;
      }
      return sortedArray;
    }
  }
}

export const sampleMemberships = [
  {
    organization_id: "12345",
    organization_name: "DC Blox",
    organization_icon: "",
    role: "member",
    services: [
      {
        service_id: "10",
        name: "support",
        ref: "10-00-0000",
        route: "/portal/support",
        attributes: {
          theme: "DCBLOX_purple",
        },
        location: {
          1024: ["20", "20"],
          1440: ["20", "20"],
          2560: ["20", "24"],
        },
        pages: [
          {
            name: "Overview",
            id: "10",
            status: "active",
            route: "/portal/support/overview",
            ref: "10-10-0000",
            order: 1,
          },
          {
            name: "Ticket History",
            id: "10",
            status: "active",
            route: "/portal/support/history",
            ref: "10-20-0000",
            order: 1,
          },
        ],
      },
      {
        service_id: "20",
        name: "account",
        ref: "20-00-0000",
        route: "/portal/account",
        attributes: {
          theme: "DCBLOX_blue",
        },
        location: {
          1024: ["20", "20"],
          1440: ["20", "20"],
          2560: ["20", "24"],
        },
      },
      {
        service_id: "30",
        name: "billing",
        ref: "30-00-0000",
        route: "/portal/billing",
        attributes: {
          theme: "DCBLOX_green",
        },
        location: {
          1024: ["20", "20"],
          1440: ["20", "20"],
          2560: ["20", "24"],
        },
      },
      {
        service_id: "40",
        name: "storage",
        ref: "40-00-0000",
        route: "/portal/storage",
        attributes: {
          theme: "DCBLOX_blue",
        },
        location: {
          1024: ["20", "20"],
          1440: ["20", "20"],
          2560: ["20", "24"],
        },
      },
      {
        service_id: "40",
        name: "online_payments",
        ref: "40-00-0000",
        route: "/portal/storage",
        attributes: {
          theme: "DCBLOX_blue",
        },
        location: {
          1024: ["20", "20"],
          1440: ["20", "20"],
          2560: ["20", "24"],
        },
      },
    ],
  },
];
